export enum AppRoutes {
	home = '/',
	match = '/match/:id',
	league = '/league/:id',
	player = '/player/:id',
	team = '/team/:id',
}
